import { readInlineData, useLazyLoadQuery } from 'react-relay';
import { UnifiedProfileFragment$key } from 'graphql/__generated__/UnifiedProfileFragment.graphql';
import {
  UnifiedProfileQuery,
  UnifiedProfileQuery$data,
} from 'graphql/__generated__/UnifiedProfileQuery.graphql';
import { UNIFIED_PROFILE_FRAGMENT } from 'graphql/UnifiedProfileFragment';
import { UNIFIED_PROFILE_QUERY } from 'graphql/UnifiedProfileQuery';
import { UNIFIED_ACCOUNT_QUERY } from 'graphql/UnifiedAccountQuery';
import { UnifiedAccountQuery } from 'graphql/__generated__/UnifiedAccountQuery.graphql';
import { AtlassianAccountUserQuery } from 'graphql/__generated__/AtlassianAccountUserQuery.graphql';
import { ATLASSIAN_ACCOUNT_USER_QUERY } from 'constants/index';

/**
 * NOTE: this return true even if the logged in user is a moderator
 * We should ideally have an effort to rename this as useIsPersonalOrModeratorView
 * and rename useIsProfilePersonalView to useIsPersonalView
 * @param internalId
 * @returns
 */
const useIsPersonalView = (internalId: string): boolean => {
  const unifiedProfile = useLazyLoadQuery<UnifiedProfileQuery>(
    UNIFIED_PROFILE_QUERY,
    { internalId },
    { fetchPolicy: 'store-or-network' },
  )?.unified?.unifiedProfile;

  let profileFragmentData;

  if (unifiedProfile && '__fragments' in unifiedProfile) {
    profileFragmentData = readInlineData<UnifiedProfileFragment$key>(
      UNIFIED_PROFILE_FRAGMENT,
      unifiedProfile as NonNullable<
        UnifiedProfileQuery$data['unified']
      >['unifiedProfile'],
    );
  }

  let isForumsModerator = false;
  if (profileFragmentData) {
    const loggedInUser = useLazyLoadQuery<AtlassianAccountUserQuery>(
      ATLASSIAN_ACCOUNT_USER_QUERY,
      {},
      { fetchPolicy: 'store-or-network' },
    )?.me?.user;

    const accountId = loggedInUser?.accountId || '';
    const account = useLazyLoadQuery<UnifiedAccountQuery>(
      UNIFIED_ACCOUNT_QUERY,
      { aaid: accountId || '' },
      { fetchPolicy: 'store-or-network' },
    )?.unified;
    isForumsModerator = account?.account?.isForumsModerator || false;
  }
  return (
    profileFragmentData?.isPersonalView ||
    profileFragmentData?.isLinkedView ||
    isForumsModerator ||
    false
  );
};

export default useIsPersonalView;
